/**
 * Global distance-analysis view ("Avstandsvisning").
 *
 * Shows a vertical drop-to-ground measurement under the power lines in the
 * loaded area. This is the *global* counterpart to path-mode's per-section
 * "Vis avstander" toggle (`pathModeState.showDistances`) — both render the same
 * vertical measurement, so the two must never be enabled at the same time.
 *
 * The `mastpointsAlongLine` tool calls `disableDistanceAnalysisMode` when it starts
 * so the global view yields to path-mode's own distance lines. The
 * two UI entry points for the global view (the toolbar button and the
 * "Visningsmodus" menu in MapSettings) disable themselves while the tool or
 * path-mode is active to keep the invariant.
 */

import { get } from 'svelte/store';

import { mapToolsStore } from '../map-tools-store';
import { useDataSources } from '../cesium-datasources';

/**
 * Turn the global distance view off and clear its measurement entities.
 *
 * Returns whether it was on. The `mastpointsAlongLine` tool uses that to carry the user's
 * intent across into path-mode (auto-checking "Vis avstander" for a fluid
 * transition). No-op — returns `false` — when the view is already off.
 */
export function disableDistanceAnalysisMode(): boolean {
	if (get(mapToolsStore).mapStoreInputMode !== 'distanceMode') return false;

	const { distanceAnalysisTerrainProfilesDataSource, distanceAnalysisPolylinesDataSource } =
		useDataSources();

	mapToolsStore.update((store) => {
		store.mapStoreInputMode = 'default';
		return store;
	});
	distanceAnalysisTerrainProfilesDataSource.entities.removeAll();
	distanceAnalysisPolylinesDataSource.entities.removeAll();

	return true;
}
